// 全站唯一的 401 refresh 协调器。services.js 与 src/api/client.js 虽然仍服务于
// 不同调用面，但必须共享同一个 single-flight 与熔断状态，避免 refresh token 轮换后互踢。

let refreshing = null;
let blockedAt = 0;
const BLOCK_MS = 30_000;

export const isAuthRefreshBlocked = () =>
  blockedAt > 0 && Date.now() - blockedAt < BLOCK_MS;

export const clearAuthRefreshBlock = () => {
  blockedAt = 0;
};

export const refreshAccessTokenShared = ({ apiBase, tokenStore }) => {
  if (isAuthRefreshBlocked()) {
    return Promise.reject(new Error('auth refresh blocked'));
  }
  if (refreshing) return refreshing;

  const refreshToken = tokenStore.getRefresh();
  // The backend's refresh endpoint authenticates with the HttpOnly refreshToken
  // cookie. localStorage is only a client-side mirror and may be absent while the
  // OAuth session is still valid, so never reject before giving the cookie a chance.
  refreshing = fetch(`${apiBase}/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(refreshToken ? { refreshToken } : {}),
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`refresh failed: HTTP ${response.status}`);
      }
      const result = await response.json();
      if (!result.accessToken) throw new Error('refresh returned no token');
      tokenStore.set(result.accessToken, result.refreshToken || refreshToken);
      clearAuthRefreshBlock();
      return result.accessToken;
    })
    .catch((error) => {
      blockedAt = Date.now();
      tokenStore.clear();
      try {
        window.dispatchEvent(
          new CustomEvent('xapi:auth-cleared', {
            detail: { reason: error.message },
          }),
        );
      } catch {}
      throw error;
    })
    .finally(() => {
      refreshing = null;
    });

  return refreshing;
};

/** 仅用于隔离单元测试状态。 */
export const resetAuthRefreshForTests = () => {
  refreshing = null;
  blockedAt = 0;
};
